import styled from 'styled-components'

export const AboutContainer = styled.div`
  display: flex;
  @media (orientation: landscape) {
    padding: 5% 20% 0% 10%;
  }
  @media (orientation: portrait) {
    padding: 10% 10% 10% 10%;
  }
`

export const AboutContent = styled.div`
  width: 100%;
  max-width: 600px;
`

export const AboutTitle = styled.div`
  color: #fff;
  font-size: 30px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 30px;
  @media (min-width: 1280px) {
    font-size: 38px;
  }
`

export const VersionCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.15);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
  
  @media (min-width: 1280px) {
    padding: 32px;
    border-radius: 20px;
  }
`

export const VersionInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: ${(props) => (props.last ? '0' : '16px')};
`

export const VersionIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(75, 175, 254, 0.15);
  color: #4BAFFE;
  flex-shrink: 0;
  
  @media (min-width: 1280px) {
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }
`

export const VersionTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const VersionLabel = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 4px;
  
  @media (min-width: 1280px) {
    font-size: 16px;
  }
`

export const VersionValue = styled.div`
  color: #ffffff;
  font-size: 18px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 600;
  line-height: 1.4;
  
  @media (min-width: 1280px) {
    font-size: 22px;
  }
`

export const ReleaseDateValue = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-family: Outfit;
  font-style: normal;
  font-weight: 500;
  line-height: 1.4;
  
  @media (min-width: 1280px) {
    font-size: 18px;
  }
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 20px 0;
`

export const DeveloperToolsContainer = styled.div`
  margin-top: 24px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`

